// extracted by mini-css-extract-plugin
export default {"signupBlockFooter":"signupBlockFooter-1EZ2j","btnSignupFooter":"btnSignupFooter-3R40V","signupBlockFooterMobile":"signupBlockFooterMobile-fX-18"};